import { transaction } from 'mobx';
import type { IUndoRedoService } from './undo-redo-service.interface';
import type { ISelectedAnimManager } from '@src/slide/application/service/selection/selected-anim-manager.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

export class UndoRedoService implements IUndoRedoService {
    private selectedAnims?: ISelectedAnimManager;
    /**
     * 撤销 (undo) 接口
     */
    public undo = (): void => {
        window.log.info('slideStore undo');
        // undo / redo 目前用时序保证 选中态逻辑 触发之前先清除所有选中态 再根据 树 节点通知 添加回来选中态
        transaction(() => {
            this.selectedAnims?.clear();
            SlideDataServices.SDKDataServices.CommandManager()?.undo();
        });
    };

    /**
     * 重做 (redo) 接口
     */
    public redo = (): void => {
        window.log.info('slideStore redo');
        // undo / redo 目前用时序保证 选中态逻辑 触发之前先清除所有选中态 再根据 树 节点通知 添加回来选中态
        transaction(() => {
            this.selectedAnims?.clear();
            SlideDataServices.SDKDataServices.CommandManager()?.redo();
        });
    };

    public setSelectedAnimsDelegate(selectedAnims: ISelectedAnimManager): void {
        if (this.selectedAnims) {
            return;
        }
        this.selectedAnims = selectedAnims;
    }
}
